/*  Searchanise Tag Hider — ONLY inside #snize_filters_block_tags
    - No setTimeout
    - Works even if Searchanise.Loaded never fires
    - Works on pagination (?page=1) because we match location.pathname
    - Removes ONLY tag filters under the TAGS block (#snize_filters_block_tags)
*/

(function () {
  const get$ = () => window.Searchanise?.$ || window.jQuery;

  const uniq = (arr) => Array.from(new Set((arr || []).filter(Boolean)));

  // ✅ ONLY remove inside TAGS block
  const removeFromTagsBlock = ($, tags) => {
    const t = uniq(tags);
    if (!t.length) return;

    const selectors = t.map(
      v => `#snize_filters_block_tags li:has(input.snize-product-filters-checkbox[value="${v}"])`
    ).join(', ');

    $(selectors).remove();
  };

  const bind = ($, ns, fn) => {
    fn(); // run once immediately
    $(document)
      .off(`Searchanise.ResultsUpdated.${ns}`)
      .on(`Searchanise.ResultsUpdated.${ns}`, fn);
  };

  // ---------------- CONFIG ----------------
  const GLOBAL_TAGS = [
    "Mens",
    "Kids",
    "AC",
    "image",
    "Unisex",
    "Camp & Kitchen",
    "Sweat Shirts",
    "Womens"
  ];

  const JACKET_COLLECTIONS = [
    '/collections/mens-jackets',
    '/collections/mens-insulated-synthetic-jackets',
    '/collections/mens-insulated-down-jackets',
    '/collections/mens-hardshell-jackets-1',
    '/collections/mens-softshell-jackets',
    '/collections/mens-fleece-jackets',
    '/collections/mens-snowsports-jackets',
    '/collections/mens-casual-jackets',

    '/collections/womens-jackets',
    '/collections/womens-insulated-synthetic-jackets',
    '/collections/womens-insulated-down-jackets',
    '/collections/womens-hardshell-jackets-1',
    '/collections/womens-softshell-jackets',
    '/collections/womens-fleece-jackets',
    '/collections/womens-snowsports-jackets',
    '/collections/womens-casual-jackets'
  ];

  const RULES = [
    // /collections/apparel
    {
      match: ['/collections/apparel'],
      ns: 'apparel',
      tags: [
        "Apparel Accessories",
        "Fishing & Outdoor Clothing",
        "Fishing and Outdoor Clothing",
        "Fishing And Outdoor Clothing",
        "FISHING & OUTDOOR CLOTHING",
        "Baselayer",
        "UploadB",
        "Belts & Suspenders",
        "Bibs & Pants",
        "Fishing Accessories",
        "Fishing Footwear",
        "Gloves and Mittens",
        "Gold",
        "Google Shopping",
        "Hat",
        "Hats",
        "Heavy Weight Camo Clothing",
        "Hiking",
        "Hooded",
        "Hunting Clothing",
        "Jackets & Parkas",
        "Light Weight Camo Clothing",
        "Lightweight Camo Clothing",
        "Long Sleeve",
        "Mens. Jackets",
        "OROL",
        "Outerwear",
        "SUN",
        "Sunglasses & Accessories",
        "Sweaters",
        "Sweatshirts",
        "Tank",
        "UPC",
        "Vests & Hats",
        "Vests & Tackle Packs",
        "Women"
      ]
    },

    // /collections/snow
    {
      match: ['/collections/snow'],
      ns: 'snow',
      tags: ["Mens", "Womens", "Camping Accessories", "Avalanche", "Snow & Ice", "Clearance", "Kids"]
    },

    // /collections/backpacking-camping
    {
      match: ['/collections/backpacking-camping'],
      ns: 'backpackingCamping',
      tags: [
        "Camping Accessories",
        "Avalanche",
        "Airbag",
        "Mens",
        "Womens",
        "Tents & Sleeping Bags",
        "TENTS & CANOPIES",
        "Kids",
        "Nordic",
        "Hiking & Backpacking",
        "Packs & Bags"
      ]
    },

    // /collections/climbing
    {
      match: ['/collections/climbing'],
      ns: 'climbing',
      tags: ["Shelter & Sleep", "Mens", "Womens"]
    },

    // /collections/footwear  (AC included)
    {
      match: ['/collections/footwear'],
      ns: 'footwear',
      tags: ["AC", "Shelter & Sleep", "Sandals", "Clearance", "Footwear", "Mountaineering Boots", "Mens", "Womens"]
    },

    // /collections/womens
    {
      match: ['/collections/womens'],
      ns: 'womens',
      tags: ["Mens", "Womens", "Jackets & Parkas", "Hiking Pants", "Apparel Accessories"]
    },

    // /collections/mens
    {
      match: ['/collections/mens'],
      ns: 'mens',
      tags: ["Mens", "Womens", "Gloves and Mittens", "Vests & Tackle Packs", "Apparel Accessories"]
    },

    // /collections/watersports
    {
      match: ['/collections/watersports'],
      ns: 'watersports',
      tags: ["Mens", "Womens"]
    },

    // /collections/essentials
    {
      match: ['/collections/essentials'],
      ns: 'essentials',
      tags: ["MensGrips & Handlebar Tapes", "Grips & Handlebar Tape", "Womens"]
    },

    // extras you had
    { match: ['/collections/mens-jackets'], ns: 'mensJackets', tags: ["Mens", "Womens"] },
    { match: ['/collections/mens-bottoms'], ns: 'mensBottoms', tags: ["Hiking Pants"] },
    { match: ['/collections/mens-accessories'], ns: 'mensAccessories', tags: ["Unisex"] },
    { match: ['/collections/men-eyewear'], ns: 'menEyewear', tags: ["Kids", "Mens", "Womens"] },
    { match: ['/collections/womens-tops'], ns: 'womenstops', tags: ["Womens"] },
    { match: ['/collections/womens-bottoms'], ns: 'womensbottoms', tags: ["Mens", "Womens"] },
    { match: ['/collections/womens-footwear'], ns: 'womensfootwear', tags: ["Sandals"] },
    { match: ['/collections/downhill-skis'], ns: 'downhillskis', tags: ["Sandals"] },
    {
      match: ['/collections/nordic'],
      ns: 'nordic',
      tags: ["Classic Nordic Ski", "Rossignol classic ski", "rossignol nordic ski"]
    },
    {
      match: ['/collections/avalanche-equipment'],
      ns: 'avalancheequipment',
      tags: ["Classic Nordic Ski", "Rossignol classic ski", "rossignol nordic ski"]
    },
    { match: ['/collections/packs'], ns: 'packs', tags: ["Packs & Bags"] },
    { match: ['/collections/camping-accessory'], ns: 'campingaccessory', tags: ["Camping", "Straps"] },
    { match: ['/collections/garmin'], ns: 'garmin', tags: ["Light & Electronics"] },
    { match: ['/collections/snowsports'], ns: 'snowsports', tags: ["Nordic Ski"] },
    { match: ['/collections/nordic-skis'], ns: 'nordicskis', tags: ["Skate XC", "Classic"] }
  ];
  // -------------- END CONFIG --------------

  const run = () => {
    const $ = get$();
    if (!$) return;

    const path = location.pathname;

    // Global tags on any collections page
    if (path.startsWith('/collections/')) {
      bind($, 'globalTags', () => removeFromTagsBlock($, GLOBAL_TAGS));
    }

    // Jackets group (removes Mens/Womens from Tags block on jacket collections)
    if (JACKET_COLLECTIONS.includes(path)) {
      bind($, 'jacketsGroup', () => removeFromTagsBlock($, ["Mens", "Womens"]));
    }

    // Per-page rules
    RULES.forEach(rule => {
      if (!rule?.match?.some(m => path.includes(m))) return;
      bind($, rule.ns, () => removeFromTagsBlock($, rule.tags));
    });
  };

  // run on DOM ready (works even if Searchanise.Loaded doesn't fire)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // also run if Searchanise Loaded event fires later
  document.addEventListener('Searchanise.Loaded', run);

})();
